export default "__VITE_ASSET__qN4Y5SIQ__"